export enum PspSubscriptionStatusEnum {
  Pending = 1,
  Active = 2,
  Cancelled = 3,
  Rejected = 4,
  Renewable = 5,
  Expired = 6,
  NotSubscribed = 7,
  Suspended = 8,
}
